import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import GenericSelection from '../../../Common/GenericSelection';

const propTypes = {
  minPurchasePrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  discountValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  discountType: PropTypes.string,
  SalesType: PropTypes.string,
  handleDiscountButtonClick: PropTypes.func,
  handleTextInputChange: PropTypes.func,
  handleSelectionChange: PropTypes.func,
};

const defaultProps = {
  minPurchasePrice: '',
  discountValue: '',
  discountType: '',
  SalesType: 'all',
  handleDiscountButtonClick: () => { },
  handleTextInputChange: () => { },
  handleSelectionChange: () => { },
};

const ByTotalPriceDiscountFields = ({
  minPurchasePrice,
  discountValue,
  discountType,
  SalesType,
  handleDiscountButtonClick,
  handleTextInputChange,
  handleSelectionChange,
}) => {
  const salesTypeOptions = [
    { label: <Translate value="all" />, value: 'all' },
    { label: <Translate value="wholesale" />, value: 'wholesale' },
    { label: <Translate value="retail" />, value: 'retail' },
  ];
  return (
  <div className="promo-fields">

      <div className="method-selection">
        <GenericSelection
          translation={<Translate value="sales_type" />}
          setSelected={({ value }) => handleSelectionChange(value, 'SalesType')}
          value={SalesType}
          options={salesTypeOptions}
          colon
        />
      </div>

    <div className="flex-row">
      <label htmlFor="total-price-discount" className="field-margin"><Translate value="min_purchase_amount" />:</label>
      <input
        id="min-purchase-text-input"
        name="minPurchasePrice"
        className="text-input-field"
        type="text"
        value={minPurchasePrice}
        onChange={handleTextInputChange}
      />
    </div>
    <div className="discount-field">
      <label htmlFor="discount" className="field-margin "><Translate value="discount" />:</label>
      <input
        id="discount-text-input"
        name="discountValue"
        className="text-input-field"
        type="text"
        value={discountValue}
        onChange={handleTextInputChange}
      />
      <ButtonToolbar>
        <Button
          bsStyle={(discountType === 'Dollar') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Dollar')}
        >
          <em className="fa fa-usd" />
        </Button>
        <Button
          bsStyle={(discountType === 'Percent') ? 'success' : 'null'}
          onClick={() => handleDiscountButtonClick('Percent')}
        >
          <em className="fa fa-percent" />
        </Button>
      </ButtonToolbar>
    </div>
  </div>
);
};

ByTotalPriceDiscountFields.propTypes = propTypes;
ByTotalPriceDiscountFields.defaultProps = defaultProps;

export default ByTotalPriceDiscountFields;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/ByTotalPriceDiscountFields.jsx